import NavBar from "../HomePage/NavBar";
import s from '../Styles/Cart.module.css';
import { Flex, Image, Box, Text } from "@chakra-ui/react"
import { Context } from "../ContextProvider/ContextProvider";
import { useContext, useEffect } from "react";
function CartPage() {

    const { cart } = useContext(Context)

    console.log("cart", cart)





    return (
        <div>
            <NavBar />

            <div className={s.main}>

                {
                    cart?.map((item) => {
                      return  <div className={s.cartcard} key={item.id}>

                            <Flex>
                                <div className={s.imagediv}>
                                    <Image className={s.image} src={item.img} />
                                </div>


                                <Box className={s.details}>
                                    <Text fontSize={'32px'} >{item.name}</Text>
                                    <Text mt='20px' fontSize={'15px'}>{item.brand}</Text>
                                    <Text mt='100px' fontSize={'30px'}>₹ {item.price}</Text>
                                </Box>


                            </Flex>


                        </div>
                    })

                }




            </div>




        </div>
    )
};

export default CartPage;